export default __webpack_public_path__ + "static/media/why-us-img-new.06c773cf.png";